export default "__VITE_ASSET__6ef57f13__"